import { TabDto } from "@/shared/dtos/tab-dto";
import { TabsDto } from "@/shared/dtos/tabs-dto";
import { MenuOptionsService } from "@/shared/services/menuOptionsService";
import { Item, TabPanel } from "devextreme-react/tab-panel";
import { useEffect, useState } from "react";
import "./ItiTabs.scss";

interface ItiTabsProps {
	tabPanelItems: any[];
	option?: string;
	selectedIndex?: any;
	onSelectedIndexChange?: (value: number) => void;
}

// Si nos pasan el parámetro option, consultaremos a la API para obtener los tabs
// (que vendrán filtrados por permisos), si no es así, usaremos los tabs que nos
// pasen por parámetro.
export default function ItiTabsComponent({
	tabPanelItems,
	option = "",
	selectedIndex,
	onSelectedIndexChange,
}: ItiTabsProps) {
	const [tabs, setTabs] = useState<string[]>([]);

	useEffect(() => {
		getTabs();
	}, []);

	const getTabs = () => {
		if (option) {
			MenuOptionsService.getUserTabs().then((res: TabsDto[]) => {
				const filteredTabs = res.filter(
					(item: TabsDto) => item.option === option,
				);
				if (filteredTabs.length > 0) {
					const textTabs = filteredTabs[0].tabs.map((a: TabDto) => {
						return a.text;
					});
					setTabs(textTabs);
				}
			});
		}
	};

	return (
		<TabPanel
			className="iti-tabs"
			selectedIndex={selectedIndex}
			swipeEnabled={false}
			onSelectedIndexChange={(e: number) => {
				if (onSelectedIndexChange) {
					onSelectedIndexChange(e);
				}
			}}
		>
			{option &&
				tabPanelItems.map(
					(item, index) =>
						tabs.includes(item.name) && (
							<Item key={index} title={item.title}>
								{item.content}
							</Item>
						),
				)}
			{!option &&
				tabPanelItems.map((item, index) => (
					<Item key={index} title={item.title}>
						<div className="mx-2">{item.content}</div>
					</Item>
				))}
		</TabPanel>
	);
}
